import AOS from 'aos';

// Import Swiper and modules from a single source
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

jQuery.noConflict();


/**
 * Animate On Scroll
 */
document.addEventListener("DOMContentLoaded", (event) => {
    AOS.init({
        once: true,
        offset: 0,
        startEvent: 'load'
    });

	// After AOS animations complete, reset button transitions
    document.querySelectorAll('.btn[data-aos]').forEach(button => {
        button.addEventListener('aos:in:end', function() {
            // Small timeout to ensure AOS is completely done
            setTimeout(() => {
                button.style.transition = ''; // Reset transition to use CSS value
                button.classList.add('aos-complete');
            }, 100);
        });
    });
});
window.addEventListener('load', (event) => {
    AOS.refresh();
});



/** 
 *  Initialize Swiper slider - Logo Carousel
 */


document.addEventListener("DOMContentLoaded", function() {
    // Wait for the DOM to be fully loaded
    const logoCarouselElements = document.querySelectorAll('.logo-carousel .swiper');
    
    // Make sure to initialize Swiper modules
    Swiper.use([Navigation, Pagination, Autoplay]);
    
    if (logoCarouselElements.length > 0) {
        // console.log('Found logo carousel elements:', logoCarouselElements.length);
        
        logoCarouselElements.forEach(function(element) {
            // Get number of slides from data attribute
            const slidesPerView = parseInt(element.getAttribute('data-slides-per-view') || 6, 10);
            
            // Store the Swiper instance in a variable
			const swiperInstance = new Swiper(element, {
				// Core options
				spaceBetween: 12,
				loop: true,
				slidesPerView: 	2,
				
				// Enable modules
				modules: [Navigation, Pagination, Autoplay],
				
				// Autoplay configuration
				autoplay: {
					delay: 2000, // 2 seconds is typically better for user experience than 1s
					disableOnInteraction: false,
					pauseOnMouseEnter: true,
				},
				
				// Pagination
				pagination: {
					el: element.querySelector('.swiper-pagination'),
					clickable: true,
					type: 'bullets',
				},
				
				// Navigation
				navigation: {
					nextEl: element.querySelector('.swiper-button-next'),
					prevEl: element.querySelector('.swiper-button-prev'),
				},
				
				// Responsive breakpoints
				breakpoints: {
					576: {
						slidesPerView: Math.min(2, slidesPerView),
						spaceBetween: 20
					},
					768: {
						slidesPerView: Math.min(3, slidesPerView),
						spaceBetween: 30
					},
					992: {
						slidesPerView: Math.min(4, slidesPerView),
						spaceBetween: 30
					},
					1200: {
						slidesPerView: slidesPerView,
						spaceBetween: 30
					}
				}
			});
            
            // Now use the instance variable to access Swiper properties
            // console.log(`Logo carousel initialized with ${slidesPerView} slides per view`);
            
            // Check if autoplay exists on the instance
            if (swiperInstance.autoplay) {
                console.log('Autoplay status:', swiperInstance.autoplay.running);
                
                // Force start autoplay if needed
                if (!swiperInstance.autoplay.running) {
                    console.log('Manually starting autoplay');
                    swiperInstance.autoplay.start();
                }
            } else {
                // console.warn('Autoplay module not available on this Swiper instance');
            }
        });
    } else {
        // console.log('No logo carousel elements found on page');
    }
});


/**
 * Initialize Swiper slider - Industry Cards
 */

document.addEventListener('DOMContentLoaded', function () {
	// console.log('Initializing Swiper...');
	var swiperContainer = document.querySelector('.industries-swiper');
	if (swiperContainer) {
		new Swiper(swiperContainer, {

			slidesPerView: 1,
			spaceBetween: 24,

			effect: 'slide',
			modules: [Navigation, Pagination, Autoplay],

			// Enable loop and autoplay	
			loop: true,
			autoplay: {
				//delay: 3000,
				pauseOnMouseEnter: true, // Stops autoplay when the mouse is over the carousel
			},
			breakpoints: {
				576: {
					slidesPerView: 3,
					spaceBetween: 20,
				},
				768: {
					slidesPerView: 3,
					spaceBetween: 30,
				},
				992: {
					slidesPerView: 3,
					spaceBetween: 30
				},
				1200: {
					slidesPerView: 4,
					spaceBetween: 30
				}
			},
			pagination: {
				el: swiperContainer.querySelector('.swiper-pagination'),
				clickable: true,
				type: 'bullets', // Enable dots (bullets) for pagination
			},
		});
	} else {
		// console.error('Swiper container not found.');
	}
});

/** 
 * Initialize Swiper slider - Case Studies
 */


document.addEventListener('DOMContentLoaded', function () {
    // console.log('Initializing Case Studies Swiper...');
    var swiperContainers = document.querySelectorAll('.case-studies-swiper');
    swiperContainers.forEach(function(swiperContainer) {
        new Swiper(swiperContainer, {
            slidesPerView: 1,
            spaceBetween: 24,
            effect: 'slide',
            modules: [Navigation, Pagination, Autoplay],
            loop: true,
            autoplay: {
                pauseOnMouseEnter: true,
            },
            breakpoints: {
                576: { slidesPerView: 2, spaceBetween: 20 },
                768: { slidesPerView: 2, spaceBetween: 30 },
                992: { slidesPerView: 3, spaceBetween: 30 },
                1200: { slidesPerView: 3, spaceBetween: 30 }
            },
            pagination: {
                el: swiperContainer.querySelector('.swiper-pagination'),
                clickable: true,
                type: 'bullets',
            },
        });
    });
});




/** 
 * Initialize Swiper slider - Hero Section
 */
document.addEventListener('DOMContentLoaded', function () {
    // console.log('Initializing Hero Swiper...');
    var swiperContainers = document.querySelectorAll('.hero-swiper');
    // console.log('Found hero-swiper elements:', swiperContainers.length);

    swiperContainers.forEach(function(swiperContainer) {
        // console.log('Creating Hero Swiper instance for:', swiperContainer);
        new Swiper(swiperContainer, {
            slidesPerView: 1,
            spaceBetween: 0,
			allowTouchMove: false, // Disable swipe on desktop
            effect: 'slide',
            centeredSlides: true,
            modules: [Navigation, Pagination, Autoplay],
            loop: true,
            autoplay: {
                delay: 2500,
                pauseOnMouseEnter: false,
            },
        });
    });
});





/**
 * Update Navbar on Scroll
 */

// Wait for DOM to be fully loaded
document.addEventListener("DOMContentLoaded", function() {
  // Get the navbar element
  const navbar = document.getElementById('main-nav');
  
  // Function to update navbar style on scroll
  function updateNavbar() {
    if (window.scrollY > 50) { // Change this value to control when the background appears
      navbar.classList.add('navbar-scrolled');
    } else {
      navbar.classList.remove('navbar-scrolled');
    }
  }
  
  // Add scroll event listener
  window.addEventListener('scroll', updateNavbar);
  
  // Call once on page load to set initial state
  updateNavbar();
});